import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import type { CampaignAnalyticsConfigData } from '@core/integrations-legacy';
import { JobCampaignsService } from '@core/integrations-legacy';

import {
  CampaignAnalyticsDataActions,
  CampaignAnalyticsDataSelectors,
} from './campaign-analytics-data.store';

@Injectable({ providedIn: 'root' })
export class CampaignAnalyticsDataStoreService {
  private readonly store = inject(Store);
  private readonly jobCampaignsService = inject(JobCampaignsService);

  public getCampaignAnalyticsData(
    codename: string,
  ): Observable<CampaignAnalyticsConfigData | null> {
    return this.store.select(CampaignAnalyticsDataSelectors.byId(codename));
  }

  public fetchCampaignAnalyticsData(codename: string): void {
    this.store.dispatch(CampaignAnalyticsDataActions.fetchOne({ payload: { id: codename } }));
  }

  public setCampaignAnalyticsData(
    codename: string,
    data: CampaignAnalyticsConfigData,
  ): Observable<any> {
    return this.jobCampaignsService.setCampaignAnalyticsConfigData(codename, data).pipe(
      tap(
        _success => {
          this.fetchCampaignAnalyticsData(codename);
        },
        _error => {
          this.fetchCampaignAnalyticsData(codename);
        },
      ),
    );
  }
}
